import React, { useEffect, useRef, useState } from 'react';
import { Alert, Button, Select } from 'antd';
import { fetchChatSuggestions } from '@/apis/chat';
import { getRequestErrorMessage } from '@/utils/requestError';
import UserIdentity from '@/components/useridentity';

const ChatUserPicker = ({ value, onChange, multiple = false, excludeIds = [], disabled = false, maxCount = 99 }) => {
  const [query, setQuery] = useState(''); const [options, setOptions] = useState([]); const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1); const [hasMore, setHasMore] = useState(false); const [error, setError] = useState('');
  const [retry, setRetry] = useState(0); const requestId = useRef(0); const paging = useRef(false);
  const selectedIds = Array.isArray(value) ? value : value ? [value] : [];
  const selectedKey = selectedIds.join(',');
  const exclude = [...new Set([...excludeIds, ...selectedIds])].join(',');
  useEffect(() => {
    const version = ++requestId.current;
    setLoading(true);
    const timer = setTimeout(async () => {
      setLoading(true); setError('');
      try {
        const result = await fetchChatSuggestions({ q: query.trim(), ...(exclude ? { exclude_ids: exclude } : {}), page, pageSize: 20 });
        if (version !== requestId.current) return;
        const selected = selectedKey.split(',').map(Number);
        setOptions(current => [...new Map([...(page === 1 ? current.filter(item => selected.includes(item.value)) : current), ...result.data.map(user => ({ value: user.id, label: <UserIdentity user={user} size={22} showUid />, title: `${user.nickname || user.username} · UID ${user.id}` }))].map(item => [item.value, item])).values()]);
        setHasMore(result.pagination.page < result.pagination.totalPages);
      } catch (err) { if (version === requestId.current) setError(getRequestErrorMessage(err, '用户搜索失败')); }
      finally { if (version === requestId.current) { setLoading(false); paging.current = false; } }
    }, 300);
    return () => { clearTimeout(timer); requestId.current += 1; };
  }, [query, page, exclude, selectedKey, retry]);
  return <>
    <Select value={value} onChange={onChange} disabled={disabled || maxCount <= 0} maxCount={multiple ? maxCount : undefined} mode={multiple ? 'multiple' : undefined} showSearch filterOption={false} searchValue={query} onSelect={() => { setQuery(''); setPage(1); }} onSearch={q => { setQuery(q.slice(0, 100)); setPage(1); }} loading={loading} options={options} placeholder="搜索用户名、昵称或 UID" style={{ width: '100%' }} onPopupScroll={event => {
      const node = event.currentTarget;
      if (hasMore && !loading && !paging.current && node.scrollTop + node.clientHeight >= node.scrollHeight - 24) { paging.current = true; setPage(n => n + 1); }
    }} />
    {error && <Alert type="warning" title={error} action={<Button size="small" onClick={() => setRetry(n => n + 1)}>重试</Button>} />}
  </>;
};
export default ChatUserPicker;
